import { render, staticRenderFns } from "./CustomerClosedTicketView.vue?vue&type=template&id=05f61d4f&"
import script from "./CustomerClosedTicketView.vue?vue&type=script&lang=js&"
export * from "./CustomerClosedTicketView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClosedTicketView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports